// Module-level switches the WP6 verification page (`?debug=maps`) flips on the MapViews the
// Renderer builds, without the Renderer knowing: the sim-solids overlay, an override source for
// solids (the synthetic hazard driver before real hazards land), and a handle on the live view for
// alignment and budget measurements. Inert unless the page enables it.
import type { Camera, WebGLRenderer } from 'three';
import type { Solid } from '@shared/maps/mapTypes';
import type { FrameView } from '../../../game/FrameView';
import type { DebugHazard } from '../arenas/types';

export interface MapViewDebugHandle {
  readonly mapId: number;
  readonly tier: string;
  /** The camera and renderer of the last frame that drew this map. */
  readonly camera: Camera | null;
  readonly renderer: WebGLRenderer | null;
  hazards(): DebugHazard[];
  /** Draw calls and triangles of the map's own objects (scene-graph count). */
  budget(): { drawCalls: number; triangles: number; shadowCasters: number };
  /** Paints hazards in a flat key color (for pixel alignment) or restores them. */
  flatHazards(on: boolean): void;
}

export interface MapDebugState {
  overlay: boolean;
  /** Replaces `MapDef.solids` for the overlay (synthetic hazards). */
  solids: ((view: FrameView, out: Solid[]) => number) | null;
  active: MapViewDebugHandle | null;
  /** Hide the arena's environment layers (sky/void/audience) for isolated checks. */
  isolate: boolean;
}

export const mapDebug: MapDebugState = { overlay: false, solids: null, active: null, isolate: false };
